<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">        
      <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
          <el-form-item>
              <el-button type="danger" icon="el-icon-plus" @click="addweight">新增重量范围</el-button>
          </el-form-item>   
      </el-form>

      <el-tag type="danger" closable  @close="closetag" v-if="showwarn==true" style="margin-top:10px">温馨提示：填写起始、结束重量时请不要与系统里的信息交叉、重叠</el-tag>
      
      <div class="backborder2" style="margin-top:10px">
	      <el-table :data="weightlists" v-loading="listLoading">
	          <el-table-column label="起始重量（kg）" align="center" width="180">
                  <template slot-scope="scope">
				      <el-input v-model="scope.row.sweight"  @blur="changesweight(scope.row)" size="small"></el-input>
				  </template>
              </el-table-column>
	          <el-table-column label="结束重量（kg）" align="center" width="180">
                  <template slot-scope="scope">
				      <el-input v-model="scope.row.eweight"  @blur="changeeweight(scope.row)" size="small"></el-input>
				  </template>
              </el-table-column>
              <el-table-column prop="numbers" label="关联区域数量" align="center" width="180"></el-table-column>
              <el-table-column label="操作" align="center">
		          <template slot-scope="scope">
		              <el-button type="danger" size="small" icon="el-icon-delete" circle @click="delweight(scope.row)"></el-button>
		          </template>
	          </el-table-column>
          </el-table>
      </div>

      <!-- 新增重量 -->
      <el-dialog title="新增重量" :visible.sync="addweightDialog" width="15%" top="15vh">
          <el-form :inline="true" size="small">
              <el-form-item style="width:100%">
                  <el-input placeholder="请输入起始配送重量" v-model="addweightquery.start">
                      <template slot="append">kg</template>
                  </el-input>         
              </el-form-item>
              <el-form-item style="width:100%">
                  <el-input placeholder="请输入结束配送重量" v-model="addweightquery.end">
                      <template slot="append">kg</template>
                  </el-input>         
              </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
              <el-button size="medium" @click="addweightDialog=false">取 消</el-button>
              <el-button size="medium" type="primary" @click="saveweight">保存</el-button>
          </div>  
      </el-dialog>

  </div>
  </transition>   
</template>

<script>

export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Shippingtemp/index",
      transitionshow:true,
      addweightDialog:false,
      weightquery: {
          act:'getweightlists',
          token:this.$cookies.get('token'),
          p:1,
          rollpage:10,
      },
      addweightquery: {
          act:'addweight',
          token:this.$cookies.get('token'),
          start:'',
          end:'',
      },
      showwarn:true,
      weightlists:[],
      listLoading:false,

    }  
  },
  mounted(){
      this.getweightlists();
  },
  methods:{

      /** 关闭提示信息 **/
      closetag() {
          this.showwarn=false;
      },

      /** 获取系统里的重量信息列表 **/
      getweightlists() {
          this.listLoading=true;
          var resource = this.$resource(this.url);
          resource.query(this.weightquery).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.listLoading=false;
              }else{
                  this.weightlists = JSON.parse(Base64.decode(res.data.Data));
                  this.listLoading=false;
              }
          }).catch((res) => {
              this.listLoading=false;
          });
      },

      /** 添加重量参数 **/
      addweight() {
          this.addweightquery.start='';
          this.addweightquery.end='';
          this.addweightDialog=true;
      },

      /** 保存重量信息 **/
      saveweight() {
    	  var resource = this.$resource(this.url);
          resource.save(this.addweightquery).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
              }else{
                  this.$message.success('添加重量信息成功！');
                  this.addweightDialog=false;
                  this.getweightlists();
              }
          }).catch((res) => {
              
          });
      },

      
      /** 编辑起始重量 **/
      changesweight(item) {
          var resource = this.$resource(this.url);
          resource.save({act:'editweight',token:this.$cookies.get('token'),id:item.id,type:1,sweight:item.sweight}).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
              }else{
                  
              }
          }).catch((res) => {
              
          });
      },

      /** 编辑结束重量 **/
      changeeweight(item) {
          var resource = this.$resource(this.url);
          resource.save({act:'editweight',token:this.$cookies.get('token'),id:item.id,type:2,eweight:item.eweight}).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
              }else{
                  
              }
          }).catch((res) => {
              
          });
      },

      /** 删除重量设置 **/
      delweight(item) {
          this.$confirm('您是否确定要删除该重量信息，继续?', '提示', { type: 'warning' }).then(() => {    	
        	  var resource = this.$resource(this.url);
              resource.save({act:'delweight',token:this.$cookies.get('token'),id:item.id}).then((res) => {
                  if(res.data.Result>0){
                      if(res.data.Result=='70001') this.$router.push('/login')
                      this.$message.error(res.data.Message);
                  }else{
                      this.getweightlists();
                  }
              }).catch((res) => {
                
              });

          }).catch(() => {
              
          }); 
      },

  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/mall/Shippingweight.vue